var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    fill: "#E73E3E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12387 8.72389C4.88956 8.9582 4.50966 8.9582 4.27535 8.72389C4.04103 8.48957 4.04103 8.10967 4.27535 7.87536L5.63299 6.51771L4.27535 5.16007C4.04103 4.92575 4.04103 4.54585 4.27535 4.31154C4.50966 4.07722 4.88956 4.07722 5.12387 4.31154L6.48152 5.66918L7.87536 4.27535C8.10967 4.04103 8.48957 4.04103 8.72389 4.27535C8.9582 4.50966 8.9582 4.88956 8.72389 5.12387L7.33005 6.51771L8.72389 7.91155C8.9582 8.14586 8.9582 8.52576 8.72389 8.76008C8.48957 8.99439 8.10967 8.99439 7.87536 8.76008L6.48152 7.36624L5.12387 8.72389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNo);
export default __webpack_public_path__ + "static/media/icon-no.a83a768c773dde32ff52bf0f2b0dd0a2.svg";
export { ForwardRef as ReactComponent };